/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const searchTypeHitTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax = 8;

export const searchTypeHitTypeDefinitionReferenceViewPredicatesMax = 10;

export const searchTypeHitTypeDefinitionReferenceViewSearchTermsItemMax = 200;

export const searchTypeHitTypeDefinitionReferenceViewSearchTermsMax = 10;

export const SearchTypeHit = zod.object({
  constantCount: zod
    .int()
    .describe('Constants and body data: TYPE→INSTANCE edges over CONTAINS or INCLUDES'),
  createdAt: zod.string(),
  cursor: zod.string().describe('Pass as `after` to continue after this row'),
  description: zod.string().nullable(),
  fieldCount: zod.int().describe('Schema fields: TYPE→TYPE edges over CONTAINS or INCLUDES'),
  isSystem: zod
    .boolean()
    .describe(
      "One of the platform's system types (the SYSTEM registry), as opposed to a type a person or group authored",
    ),
  kind: zod
    .enum(['complex', 'primitive'])
    .describe(
      'complex when the type has an outgoing CONTAINS or INCLUDES edge (a field, a constant or a template body); a RELATES_TO-only type is primitive',
    ),
  lineageUuid: zod.uuid().describe('UUID v4 identifier'),
  name: zod.string(),
  parentTypeName: zod.string().nullable(),
  parentTypeUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
  typeDefinition: zod
    .object({
      conformance: zod.enum(['open', 'lax', 'strict']).optional(),
      description: zod.string().nullish(),
      enums: zod
        .array(
          zod.object({
            label: zod.string(),
            value: zod.string(),
          }),
        )
        .nullish(),
      file: zod
        .object({
          allowedFormats: zod
            .array(
              zod.enum([
                'pdf',
                'doc',
                'docx',
                'xls',
                'xlsx',
                'csv',
                'txt',
                'jpeg',
                'png',
                'webp',
                'gif',
                'heic',
                'md',
                'html',
                'mp3',
                'm4a',
                'wav',
                'mp4',
                'mov',
                'webm',
              ]),
            )
            .min(1)
            .optional(),
        })
        .nullish(),
      metadata: zod.record(zod.string(), zod.unknown()).nullish(),
      reference: zod
        .object({
          carbonCopy: zod.boolean().optional(),
          creation: zod.enum(['forbidden', 'optional', 'required']).optional(),
          edgeType: zod.enum(['INCLUDES', 'RELATES_TO']).optional(),
          typeLineageUuid: zod.uuid(),
          typeUuid: zod.uuid(),
          view: zod
            .object({
              predicates: zod
                .array(
                  zod.object({
                    op: zod.enum(['exists', 'eq', 'contains', 'gte', 'lte']),
                    pathTypeUuids: zod
                      .array(zod.uuid())
                      .min(1)
                      .max(searchTypeHitTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax),
                    value: zod.string().optional(),
                    valueType: zod
                      .enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME'])
                      .optional(),
                  }),
                )
                .max(searchTypeHitTypeDefinitionReferenceViewPredicatesMax)
                .optional(),
              searchTerms: zod
                .array(
                  zod
                    .string()
                    .min(1)
                    .max(searchTypeHitTypeDefinitionReferenceViewSearchTermsItemMax),
                )
                .max(searchTypeHitTypeDefinitionReferenceViewSearchTermsMax)
                .optional(),
            })
            .nullish(),
        })
        .nullish(),
      signature: zod.looseObject({}).nullish(),
    })
    .nullable()
    .describe(
      'Stored TYPE configuration: description, arbitrary metadata, ENUM value\/label pairs, and the reference \/ file \/ signature field bags.',
    ),
  updatedAt: zod.string(),
  uuid: zod.uuid().describe('UUID v4 identifier'),
  valueType: zod.string().nullable(),
  variant: zod.enum(['TYPE']),
  viewerPermissions: zod
    .array(zod.enum(['READ', 'SHARE', 'COPY', 'CONTRIBUTE', 'EDIT', 'DELETE']))
    .describe(
      'What the acting principal may do to this type: READ, plus each write permission the write paths would grant it (for showing Edit, Delete or Share). Evaluated for the performAs context, so a group-authored type shows EDIT to its admin only under performAs GROUP.',
    ),
});

export type SearchTypeHit = zod.input<typeof SearchTypeHit>;
export type SearchTypeHitOutput = zod.output<typeof SearchTypeHit>;
